module.exports = __webpack_public_path__ + "static/img/border-1.0d4a04c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/border-1.png
// module id = 0cjA
// module chunks = 0